import React from 'react';
import {RouteProviderConfig} from '@shared/route/types';

const RouteContext = React.createContext<RouteProviderConfig>({
  // @ts-ignore
  routePaths: {},
});

export default RouteContext;
